module.exports = __webpack_public_path__ + "img/icon-arrow-right.39b38945.svg";